// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2isx5","title":"InfoRow_title__2Jc8Q"};